import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ServiceProvider, Portfolio } from '../types'

interface ServiceProviderState {
  serviceProviderList: ServiceProvider[]
  selectedServiceProvider: ServiceProvider | null
  portfolioList: Portfolio[]
  selectedPortfolio: Portfolio | null
}

const initialState: ServiceProviderState = {
  serviceProviderList: [],
  selectedServiceProvider: null,
  portfolioList: [],
  selectedPortfolio: null,
}

const serviceProviderSlice = createSlice({
  name: 'serviceProvider',
  initialState,
  reducers: {
    setServiceProviderList: (
      state,
      action: PayloadAction<ServiceProvider[]>,
    ) => {
      state.serviceProviderList = action.payload
    },
    setSelectedServiceProvider: (
      state,
      action: PayloadAction<ServiceProvider | null>,
    ) => {
      state.selectedServiceProvider = action.payload
    },
    setPortfolioList: (state, action: PayloadAction<Portfolio[]>) => {
      state.portfolioList = action.payload
    },
    setSelectedPortfolio: (state, action: PayloadAction<Portfolio | null>) => {
      state.selectedPortfolio = action.payload
    },
  },
})

export const {
  setServiceProviderList,
  setSelectedServiceProvider,
  setPortfolioList,
  setSelectedPortfolio,
} = serviceProviderSlice.actions

export default serviceProviderSlice.reducer
